/**
 * Русское склонение по числу: `1 новое`, `2 новых`, `5 новых`, `11 новых`, `21 новое`.
 *
 * Нужна там, где подпись с числом собирается на фронте, а не приезжает готовой строкой
 * с сервера (ср. `Badges.todayLabel` — то, что СЧИТАЕТ сервер, фронт не трогает; здесь же
 * контракт даёт только голое число — `NotificationFeed.unreadCount` — и подписи «N новых»
 * в схеме нет, макет её тоже просто печатает как текст на статичном примере с `count === 3`).
 *
 * Стандартное правило (mod 10 / mod 100, с исключением 11-14):
 *   один — 1, 21, 31, … (но не 11)
 *   мало — 2-4, 22-24, … (но не 12-14)
 *   много — все остальные, включая 0 и 11-14
 */
export function pluralizeRu(count: number, [one, few, many]: [string, string, string]): string {
  const mod10 = count % 10
  const mod100 = count % 100

  if (mod10 === 1 && mod100 !== 11) return one
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return few
  return many
}
